<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('holiday.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('holiday.holidayNameKh') }}</label>
              <div>
                <ts-input v-model="model.holiday_name_kh" />
                <div class="invalid-feedback" v-if="errors.has('holiday_name_kh')">
                  {{ errors.first('holiday_name_kh') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('holiday.holidayNameEn') }}</label>
              <div>
                <ts-input v-model="model.holiday_name_en" />
                <div class="invalid-feedback" v-if="errors.has('holiday_name_en')">
                  {{ errors.first('holiday_name_en') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('holiday.holidayDate') }}</label>
              <div>
                <ts-date-picker-input v-model="model.holiday_date" />
                <div class="invalid-feedback" v-if="errors.has('holiday_date')">{{ errors.first('holiday_date') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">{{ $t('holiday.holidayDescription') }}</label>
              <div>
                <ts-textarea v-model="model.holiday_description" rows="3" />
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 ts-text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button
              outline
              color="primary"
              class="ml-2"
              :waiting="savingAndNew"
              @click.prevent="saveAndNew"
              v-if="editData === undefined"
              >{{ $t('button.createAndNew') }}</ts-button
            >
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">
              {{ editData ? $t('button.update') : $t('button.create') }}
            </ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'

export default {
  name: 'holiday-form',
  props: ['editData', 'year'],
  data() {
    const model = {
      holiday_name_kh: this.editData ? this.editData.holiday_name_kh : '',
      holiday_name_en: this.editData ? this.editData.holiday_name_en : '',
      holiday_date: this.editData ? this.editData.holiday_date : '',
      holiday_description: this.editData ? this.editData.holiday_description : ''
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      savingAndNew: false
    }
  },
  methods: {
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/holiday/update', {
          id: this.editData.record_id,
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/holiday/create', this.model)
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/holiday/fetch', { cycle_year: this.year }).then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          if (error.errors) this.errors = new Errors(error.errors)
          else this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
        })
        .finally(() => {
          this.savingAndNew = false
        })
    }
  }
}
</script>
